import { createAsyncThunk } from "@reduxjs/toolkit";

import {
  addLocationGradeApi,
  fetchLocationGradesByLocation,
  removeLocationGradeApi,
} from "../../apis/locationGrades";

export const fetchLocationGrades = createAsyncThunk(
  "locationGrades/fetchForLocation",
  async ({ locationId }: { locationId: string }, { rejectWithValue }) => {
    try {
      const result = await fetchLocationGradesByLocation(locationId);
      return result;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const addLocationGrade = createAsyncThunk(
  "locationGrades/add",
  async (
    { locationId, gradeId }: { locationId: string; gradeId: string },
    { rejectWithValue }
  ) => {
    try {
      const result = await addLocationGradeApi({ location_id: locationId, grade_id: gradeId });
      return result;
    } catch (error: any) {
      const msg = error?.response?.data?.message || error?.message || "Failed to add grade";
      return rejectWithValue(msg);
    }
  }
);

export const removeLocationGrade = createAsyncThunk(
  "locationGrades/remove",
  async (
    { locationId, locationGradeId }: { locationId: string; locationGradeId: string },
    { rejectWithValue }
  ) => {
    try {
      await removeLocationGradeApi(locationGradeId);
      return { locationId, locationGradeId };
    } catch (error: any) {
      const msg = error?.response?.data?.message || error?.message || "Failed to remove grade";
      return rejectWithValue(msg);
    }
  }
);
